<template>

<div class="container-fluid bg-episode min-vh-100">  

    <div class="episode container pt-5 my-5">

    <h1 class="display-1 py-5">Episode</h1>
    <div v-if="episode">
        <h3 class="display-5 pb-5">{{ episode.name }}</h3>
        <p class="fw-semibold">{{ episode.air_date }}</p>
        <p class="fw-semibold">{{ episode.episode }}</p>

        <p>
            <button @click="fetchcharacters(episode.characters)" 
                    class="btn btn-secondary m-5"
                    data-bs-toggle="collapse" data-bs-target="#collapseCharList" aria-expanded="false" aria-controls="collapseCharList">
                    Episode Characters</button>

                <div v-if="episodechars" class="collapse" id="collapseCharList">

                <div class="row row-cols-1 row-cols-md-5 g-4 justify-content-evenly">
                
                    <div v-bind:key="char" v-for="(char) in episodechars" >
                        <div v-if="char">
                            <div class="card">
                                <div class="card-header">
                                    {{char.status}}
                                </div>
                                <div class="card-body">
                                    <router-link :to="{name:'character', params:{id:char.id}}" class="routerlink">
                                        <a>{{char.name}}</a>
                                    </router-link>
                                </div>
                                <div class="card-footer">
                                    {{char.species}}
                                </div>
                            </div>
                        </div>
                    </div>
        
                </div>
                </div>
        </p>

    </div>
    <div v-else class="display-6">Loading...</div>
    
    </div>

</div>

</template>

<script>
import { ref } from 'vue'
import getCharacters from '@/composables/characters/getCharacters'
export default {
    props:['id'],
    setup(props){
        console.log(props)
        const prop = ref(props)
        return { prop }
    },
    mounted() {
        var url='';
        if( !this.prop.id || this.prop.id==='undefined') {
            var epid = Math.floor(Math.random() * 51);
            url = 'https://rickandmortyapi.com/api/episode/' + epid
        } else {
            url = 'https://rickandmortyapi.com/api/episode/' + this.prop.id
        }

        fetch(url)
        .then( response => response.json() )
    .then( data => { this.episode = data/*, this.episodechars = data.characters*/ }  )
        .catch( error => console.log( error.message ) )
    },
    data() {
        return {
            episode: { },
            episodechars:[ ]
        }
    },
    methods: {
        fetchcharacters(chars) {
            const{ characters, loadch } = getCharacters(chars)
            loadch()
            // console.log(characters)
            this.episodechars = characters
            return { characters }
        },
    }
}
</script>

<style scoped>
.bg-episode  {
    background-color:thistle;
    background-image: var(--bs-gradient);    
}
</style>